import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";

import { metaActions } from "@store";

import Filter from "../search/blocks/Filter";
import Search from "../search/blocks/Search";
import Results from "./blocks/Results";

import { fetchWrapper } from "@helpers/fetchwrapper";

import styles from "../search/styles/page.module.css";

const filterNames = ["cities"];
const hiddenFilterNames = ["companies", "faculty", "category"];

function Page(props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
 
  const getFilter = useCallback(() => {
    let result = [];
    for (let i = 0; i < filterNames.length; i++) {
      let params = searchParams.get(filterNames[i]);
      if (params) {
        result = result.concat(
          params.split(",").map((t) => {
            return {
              name: filterNames[i],
              value: t,
            };
          })
        );
      }
    }
    return result;
  }, [searchParams]);

  const [load, setLoad] = useState(false);
  const [filter, setFilter] = useState(getFilter());
  const [searchResult, setSearchResult] = useState({
    filter: [],
    data: [],
    total: 0,
    totals: [],
  });

  const submitSearch = useCallback(
    (query) => {
      let result = {};
      result.query = query;
      setSearchParams(result);
    },
    [setSearchParams]
  );

  const submitFilter = useCallback(() => {
    let result = {};
    result.query = searchParams.get("query") || "";
    for (let i = 0; i < filterNames.length; i++) {
      result[filterNames[i]] = filter
        .filter((p) => p.name === filterNames[i])
        .map((p) => p.value)
        .join(",");
    }
    setSearchParams(result);
  }, [filter, searchParams, setSearchParams]);

  const submitFilterClear = useCallback(() => {
    let result = {};
    result.query = searchParams.get("query") || "";
    for (let i = 0; i < filterNames.length; i++) {
      result[filterNames[i]] = filter
        .filter((p) => p.name === filterNames[i])
        .map(() => "")
        .join(",");
    }
    setSearchParams(result);
  }, [filter, searchParams, setSearchParams]);

  const search = useCallback(
    (offset) => {
      setLoad(true);
      let query = searchParams.get("query") || "";

      let filter = getFilter();
      let requestFilters = {};
      if (filter.length > 0) {
        for (let i = 0; i < filterNames.length; i++) {
          let name = filterNames[i];
          if (!requestFilters[name]) {
            requestFilters[name] = [];
          }
          filter.forEach((f) => {
            if (f.name === name) {
              requestFilters[name].push(f.value);
            }
          });
        }
      }

      let data = {
        text: query,
        types: [4],
        limit: 5,
        offset: offset,
      };

      for (let i = 0; i < filterNames.length; i++) {
        let name = filterNames[i];
        if (requestFilters[name] && requestFilters[name].length > 0) {
          data[name] = requestFilters[name];
        }
      }
 
      fetchWrapper
        .post(`/v1/api/app/findCompaniesWithFaculty`, data)
        .then((res) => {
          setSearchResult({
            data: res.Data,
            filter: res.Filters,
            total: res.Total,
            totals: res.Totals,
          });
          setLoad(false);
        });
    },
    [searchParams, getFilter]
  );

  useEffect(() => {
    search(0);
  }, [searchParams, search]);

  useEffect(() => {
    setFilter(getFilter());
  }, [getFilter]);

  useEffect(() => {
    dispatch(
      metaActions.setData({
        icon: "/faviconCollege.ico",
        title: "Школы Республики Башкортостан",
        description:
          "Поиск общеобразовательных организаций Республики Башкортостан. Адреса, контакты, официальные сайты школ.",
        link: [
          {
            rel: "canonical",
            href: "/obrazovanie-v-bashkortostane/schools-search",
          },
        ],
      })
    );
  }, [dispatch]);

  return (
    <div className="container mt-xl-5 ps-xl-0 pe-xl-0 ps-3 pe-3">
      <Animation
        animationIn={animationStyles.swipeLeftIn}
        animationOut={animationStyles.swipeRightOut}
      >
        <div className="row justify-content-center p-1">
          <div className={`col-xl-3 col-12 ${styles.block}`}>
            <Filter
              load={load}
              data={searchResult.filter.filter(
                (f) => !hiddenFilterNames.includes(f.Name)
              )}
              values={filter}
              set={setFilter}
              submit={submitFilter}
              clear={submitFilterClear}
            />
          </div>
          <div className={`col-xl-9 col-12 ${styles.block}`}>
            <Search
              query={searchParams.get("query")}
              sumbit={submitSearch}
              setResults={setSearchResult}
              setFilterUser={setFilter}
              className="mb-4"
            />
            <Results load={load} results={searchResult} onChangePage={search} />
          </div>
        </div>
      </Animation>
    </div>
  );
}

export default Page;
